import * as React from 'react';
import { useSearch } from '@elastic/react-search-ui';
import { Config } from '../../helper';

export default function OpenSearchClearAllFiltersButton() {
  const { clearFilters, filters, searchTerm, setSearchTerm } = useSearch();

  if (!filters.length && !searchTerm) return null;

  // Reset both the facet filters and the search term. `clearFilters()` alone leaves the
  // search box populated; the mobile offcanvas Clear also routes through this button.
  const clearAll = () => {
    setSearchTerm('');
    clearFilters();
  };

  return (
    <button className='clear-filters p--medium' onClick={clearAll}>
      {Config.I18n.Filters.ClearAll}
    </button>
  );
}
